import React from 'react';
import { ReactComponent as Logo } from '../../assets/images/hey-logo.svg';
import { ReactComponent as Figma } from '../../assets/images/figma.svg';
import { ReactComponent as Sketch } from '../../assets/images/sketch.svg';
import './style.css';
import { TwitterShareButton} from 'react-twitter-embed';

export default function Navbar() {
  return (
    <div className='nav-wrapper flex w-full justify-center md:justify-between px-24'>
      <div className='logo-wrapper w-full flex main-font justify-center md:justify-between'  width="640" height="360">
        <Logo className='logo'/>
        <div className="hidden centerContent interact-icon sm:block">
          <div className="selfCenter">
          <TwitterShareButton 
              url="https://hey.qed42.com/"
              options={{
                text:"Play with Hey! — A library of illustrations for everyone by @qed42",
                size: 'large'
            }} placeholder={<div style={{color:'white'}}>Loading...</div>}>
          </TwitterShareButton>
          </div>
        </div>
      </div>
      {/* <div className='nav-cta-wrapper self-end hidden md:flex '>
        <span className='text-white secondary-font'>for</span>
        <div className='flex justify-center items-center bg-white w-10 h-10 rounded-full ml-4 open-link' style={{zIndex:30}}>
          <a href="https://gum.co/kyoKZ" className="open-link"><Figma /></a>
        </div>
        <div className='flex justify-center items-center bg-white w-10 h-10 rounded-full ml-4 open-link' style={{zIndex:30}}>
          <a href="https://gum.co/kyoKZ" className="open-link"> <Sketch /> </a> 
        </div>
      </div> */}
    </div>
  )
}